import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import Select from "@/components/Selects/Platform";

const Element = ({ paramKey = "platform" }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultValue = useMemo(() => {
    if (searchParams.has(paramKey)) {
      return searchParams.get(paramKey).split(",");
    }
    return [];
  }, [searchParams, paramKey]);

  const onChange = (value) => {
    searchParams.delete("pageIndex");
    searchParams.delete("pageSize");

    if (value && value.length > 0) {
      searchParams.set(paramKey, value.join(","));
      setSearchParams(searchParams);
    } else {
      searchParams.delete(paramKey);
      setSearchParams(searchParams);
    }
  };

  return (
    <Select
      value={defaultValue}
      mode="multiple"
      allowClear={true}
      placeholder="Platform"
      onChange={onChange}
      style={{ minWidth: "200px" }}
    />
  );
};

export default Element;
